export default "__VITE_ASSET__DfS0yVUs__"